import EditorialSection from 'components/EditorialSection';
import Section from 'components/Section';
import React from 'react';
import EfreiLogo from 'assets/schools/Efrei.png';
import UpcLogo from 'assets/schools/upc.png';
import ConcordiaLogo from 'assets/schools/Concordia.png';
import './css/formations.css';

const pad = n => String(n).padStart(2, '0');

const EDUCATION = [
  {
    id: 'efrei',
    institution: 'EFREI Paris',
    degree: 'Software Engineering — MSc',
    location: 'Paris, France',
    category: 'Software engineering school',
    logo: EfreiLogo,
    alt: 'EFREI Paris logo',
  },
  {
    id: 'upc',
    institution: 'Universitat Politècnica de Catalunya',
    degree: 'Image Processing & Artificial Intelligence — Exchange',
    location: 'Barcelona, Spain',
    category: 'Image processing & Artificial intelligence',
    logo: UpcLogo,
    alt: 'Universitat Politècnica de Catalunya logo',
  },
  {
    id: 'concordia',
    institution: 'Concordia University',
    degree: 'Software & Data Engineering — Exchange',
    location: 'Montreal, Canada',
    category: 'Software & data engineering',
    logo: ConcordiaLogo,
    alt: 'Concordia University logo',
  },
];

const ListFormations = ({ id, sectionRef }) => (
  <Section
    className="formation"
    as="section"
    aria-labelledby={`${id}-title`}
    ref={sectionRef}
    id={id}
    tabIndex={-1}
  >
    <EditorialSection
      index={3}
      eyebrow="Education"
      title="Education"
      headingId={`${id}-title`}
    />

    <ol className="formation__rows">
      {EDUCATION.map((entry, i) => (
        <li
          key={entry.id}
          className="formation__row"
          data-logo={i % 2 === 0 ? 'left' : 'right'}
        >
          <figure className="formation__plate">
            <img
              className="formation__logo"
              src={entry.logo}
              alt={entry.alt}
              width="400"
              height="400"
              loading="lazy"
              decoding="async"
            />
          </figure>

          <div className="formation__body">
            <span className="formation__num" aria-hidden>
              {pad(i + 1)}
            </span>
            <span className="formation__category">{entry.category}</span>
            <h3 className="formation__institution">{entry.institution}</h3>
            <p className="formation__degree">{entry.degree}</p>
            <span className="formation__location">{entry.location}</span>
          </div>
        </li>
      ))}
    </ol>
  </Section>
);

export default ListFormations;
